import classnames from 'classnames';
import React__default from 'react';
import ownClasses from './index.module.scss.js';

const ItemAdditionalInfo = ({ className, infos, display = 'Inline', columns = 3, }) => {
    if (!infos || !infos.length) {
        return null;
    }
    return (React__default.createElement("div", { className: classnames(className, ownClasses.container, ownClasses[display.toLowerCase()], {
            [ownClasses['grid-columns-3']]: columns === 3,
            [ownClasses['grid-columns-4']]: columns === 4,
        }) }, infos.map((info, index) => (React__default.createElement("p", { className: classnames('body-text', 'book', 'small', ownClasses.info, {
            [ownClasses.placeholder]: info.startsWith('- ('),
        }), key: `info-${index}` }, info)))));
};

export { ItemAdditionalInfo };
//# sourceMappingURL=index.js.map
